import _toConsumableArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/codebuild/output/src2483311815/src/git-codecommit.eu-west-1.amazonaws.com/v1/repos/sfx_itransfer_agent_portal/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import React__default, { useState } from 'react';
import Icon, { IconTypes } from './Icon.js';
import AccordionGroup$1 from './AccordionGroup.js';
import { C as Consumer } from '../context-6be2d352.js';
import 'prop-types';
import '../utils-e0c7329c.js';
function Accordion(_ref) {
  var className = _ref.className,
    id = _ref.id,
    renderTitle = _ref.renderTitle,
    renderContent = _ref.renderContent,
    renderFooter = _ref.renderFooter;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAccordion = _useState2[0],
    setShowAccordion = _useState2[1];
  return /*#__PURE__*/React__default.createElement(Consumer, null,
  // Function is considered like a react component
  function (value) {
    var opened = value.opened,
      setOpened = value.setOpened; // props from Provider
    if (id === opened) {
      setShowAccordion(true);
    } else {
      setShowAccordion(false);
    }
    var handleClick = function handleClick() {
      if (showAccordion) {
        setOpened('');
      } else {
        setOpened(id);
      }
    };
    return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("div", {
      className: [].concat(_toConsumableArray(Array.isArray(className) ? className : [className]), ['sendbird-accordion__panel-header']).join(' '),
      id: id,
      role: "switch",
      "aria-checked": false,
      onClick: handleClick,
      onKeyDown: handleClick,
      tabIndex: 0
    }, renderTitle(), /*#__PURE__*/React__default.createElement(Icon, {
      type: IconTypes.CHEVRON_RIGHT,
      className: ['sendbird-accordion__panel-icon-right', 'sendbird-accordion__panel-icon--chevron', showAccordion ? 'sendbird-accordion__panel-icon--open' : ''].join(' '),
      height: "24px",
      width: "24px"
    })), showAccordion && /*#__PURE__*/React__default.createElement("div", {
      className: "sendbird-accordion"
    }, /*#__PURE__*/React__default.createElement("div", {
      className: "sendbird-accordion__list"
    }, renderContent()), renderFooter && /*#__PURE__*/React__default.createElement("div", {
      className: "sendbird-accordion__footer"
    }, renderFooter())));
  });
}
var AccordionGroup = AccordionGroup$1;
export { AccordionGroup, Accordion as default };